<template>
    <div class="profile app-container">
        <v-row class="mx-0">
            <div id="profile-menu">
                <profile-menu @logout="logout"></profile-menu>
            </div>
        </v-row>
    </div>
</template>

<script>
    import ProfileMenu from '../../../app-front/components/profile/menu';
    import ProfilePersonal from '../../../app-front/components/profile/personal';

    import '../../../../sass/app-front/profile.scss';

    export default {
        name: "Profile",
        components:{ProfileMenu, ProfilePersonal},
        data(){
            return {
                isDataReceived: true,
                profileData: {}
            }
        },
        methods: {
            logout() {
                this.initLogout();
            }
        },
        watch: {
            isUserLoggedIn: function() {
                if(!this.isUserLoggedIn) {
                    this.$router.push('/').then(() => {});
                }
            }
        }
    }
</script>

<style scoped>

</style>
